import 'babel-polyfill';
import { createApp } from 'vue';
import Antd from 'ant-design-vue';

import App from './App.vue';
import store from './store'
import router from './router';
// import 'ant-design-vue/dist/antd.css';
import '@/style/index.less';
import 'ant-design-vue/dist/antd.variable.min.css';
import { setupInterceptors } from '@/utils/axios';

const app = createApp(App);
app.use(Antd); 
app.use(store);
app.use(router);
setupInterceptors(app, store, router);
app.mount('#app');
